<template lang="pug">
    div
        bread-crumb(:linkBreadCrumb="linkBreadCrumb")
        #dived
            model-data-table(
                loading-text="Cargando familias..."
                no-data-text="Sin familias."
                no-search
                ref="table"
                remind-key='wh-family-list'
                v-bind="tableProps"
                @remove="deleteItem"
                no-detail
                :no-remove="!$can('DELETE_PRODUCT_FAMILY')"
                )
                template( slot="actions" slot-scope="props" )
                    v-btn-action(
                        color="blue darken-4"
                        tooltip="Detalle"
                        @click="submitShow(props.item)"
                        v-if="$can('VIEW_DETAIL_PRODUCT_FAMILY')"
                        )
                        v-icon remove_red_eye
                    v-btn-action(
                        color="green darken-4"
                        tooltip="Subfamilia"
                        @click="submitSubFamily(props.item)"
                        v-if="$can('VIEW_DETAIL_PRODUCT_SUBFAMILY')"
                        )
                        v-icon people
            v-dialog(v-model="dialogCreateFamily" width='800')
                v-toolbar.primary(dark)
                    span.title {{showEdit ? 'Editar' : 'Crear'}} Familia
                    v-spacer
                    v-switch.ma-0.pt-4(
                      label="editar"
                      style="position: absolute; right: 20px;"
                      v-model="editable"
                      v-if="!!showEdit"
                      )
                v-card.pa-4
                  v-form(ref="form")
                    v-text-field(
                      label="Nombre"
                      outline
                      v-model="familyName"
                      :disabled="!!showEdit && !editable"
                      @keydown.enter="handleFamily"
                      :rules="[v => !!v || 'Campo Obligatorio']"
                      )
                    v-btn(
                      block
                      :color="colors.secondary"
                      :disabled="!!showEdit && !editable"
                      @click="handleFamily"
                      ) {{showEdit ? 'Editar' : 'Crear'}} Familia
</template>

<script>
//-
import {
    ModelDataTable,
    ModelForm,
    VBtnAction,
} from '@/components/reusable_components/next'
import { BreadCrumb } from '../../components/reusable_components'
import ExampleDTService from '@/services/api/ExampleDTService'
import FamilyDTService from '@/services/api/family/FamilyDTService'
import { mapActions, mapState } from 'vuex'
//-
import { DELETE_ITEM } from '@/components/SnackbarModal/SnackbarActions'
import FamilyServices from '@/services/api/family/FamilyServices'
//-
import MdlFamily from '../../models/Warehouse/WhFamily'
import HeadersFamily from './headers'
import FiltersFamily from './filters'
import FieldsFamilyDetails from './FieldsCreate'
//
export default {
    name: 'family-list',
    props: {},
    data: function() {
        return {
            service: FamilyDTService,
            headers: HeadersFamily,
            filters: FiltersFamily,
            selected: [],
            itemDeleteId: null,
            linkBreadCrumb: [
                {
                    text: 'Listado Familias',
                    disabled: true,
                },
            ],
            fields: FieldsFamilyDetails,
            modelData: {},
            formDataCreate: {},
            dialogCreateFamily: false,
            dialog: false,
            isEditable: false,
            familyObj: {},
            familyName: '',
            showEdit: null,
            editable: false,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        tableProps() {
            return {
                service: MdlFamily,
                headers: this.headers,
                filters: this.filters,
            }
        },
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        handleSubmitCreate: function(data) {
            new MdlFamily(data)
                .save()
                .then(r => this.handleResponse(r, 1))
                .catch(this.showErrorSnackbar)
        },
        submitEditFamily: function(data) {
            new MdlFamily(data)
                .save()
                .then(r => this.handleResponse(r, 2))
                .catch(this.showErrorSnackbar)
        },
        handleResponse(response, opt) {
            if (response.status === 'success') {
                switch (opt) {
                    case 1:
                        this.dialogCreateFamily = false
                        break
                    case 2:
                        this.dialog = false
                        this.$refs.form.editable = false
                        break
                }
                return this.showSuccessSnackbar(opt)
            }
            //
            return this.showErrorSnackbar(response)
        },
        showSuccessSnackbar(opt) {
            this.$refs.table.refresh()
            let message = opt === 1 ? 'creada' : 'editada'
            this.initSnackbar(
                this.fillSnack(
                    'success',
                    'Éxito',
                    `Familia ${message} exitosamente.`,
                    false,
                    3000
                )
            )
        },
        showErrorSnackbar(response) {
            this.initSnackbar(
                this.fillSnack('error', 'Error', response, false, 3000)
            )
        },
        submitShow: function(event) {
            this.showEdit = event
            this.familyName = this.showEdit.family
            this.dialogCreateFamily = true
            //this.modelData = event
            //this.dialog = true
        },
        submitSubFamily: function(event) {
            this.$router.push(`/families/${event.id}`)
        },
        deleteItem(event) {
            this.resetSnackbarState()
            this.setMessageConfirmSnack('ELIMINAR')
            let payload = this.fillSnack(
                'warning',
                'Advertencia',
                '¿Desea eliminar familia?'
            )
            this.initSnackbar(payload)
            this.itemDeleteId = event.item.id
        },
        reset() {
            this.modelData = {}
        },
        handleFamily(e) {
            e.preventDefault()
            e.stopPropagation()
            if (!this.$refs.form.validate()) return
            if (!this.showEdit)
                this.handleSubmitCreate({ family: this.familyName })
            else {
                let f = this.showEdit
                f.family = this.familyName
                f.save()
                    .then(r => {
                        this.$refs.table.refresh()
                        this.showEdit = false
                        this.dialogCreateFamily = false
                        this.showSuccessSnackbar(2)
                    })
                    .catch(this.showErrorSnackbar)
            }
        },
    },
    watch: {
        async responseConfirm(val) {
            //
            if (val === 'ELIMINAR') {
                this.resetSnackbarState()
                let response = await FamilyServices.deleteFamily(
                    this.itemDeleteId
                )
                if (response.status == 200) {
                    let payload = this.fillSnack(
                        'success',
                        'Éxito',
                        'Familia eliminada exitosamente.'
                    )
                    this.initSnackbar(payload)
                    this.$refs.table.refresh()
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.error
                    )
                    this.initSnackbar(payload)
                }
            }
        },
        dialogCreateFamily(v) {
            if (!v) {
                this.familyName = ''
                this.showEdit = null
                this.editable = false
            }
        },
    },
    components: {
        'model-data-table': ModelDataTable,
        'model-form': ModelForm,
        'bread-crumb': BreadCrumb,
        'v-btn-action': VBtnAction,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    beforeMount: function() {
        this.setTitleTopBar('Listado de familias')
        this.$setItemsTopBar([
            {
                text: 'crear familia',
                icon: 'add',
                can: 'CREATE_PRODUCT_FAMILY',
                action: () => (this.dialogCreateFamily = true),
            },
        ])
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_PRODUCT_FAMILY')) ctx.$router.push('/')
        })
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
